import styles from './styles.module.css';
import { Select, SelectItem } from '@plone/components';
import '@plone/components/src/styles/basic/Select.css';
import '@redturtle/qubicaamf-theme/components/Header/customSelect.css';

import { useIntl, defineMessages, type MessageDescriptor } from 'react-intl';
import config from '@plone/registry';

const messages = defineMessages({
  qubica_locale_selector_title: {
    id: 'qubica_locale_selector_title',
    defaultMessage: 'QubicaAMF Local Websites',
  },
});

type LocalSite = {
  id: string;
  href: string;
  title: string | MessageDescriptor;
};

export default function LocalWebSiteMenu() {
  const intl = useIntl();
  const { qubicaLocalSites = [], qubicaCurrentSiteId } = config.settings as {
    qubicaLocalSites?: LocalSite[];
    qubicaCurrentSiteId?: string;
  };
  // Every site (corporate or local) shows all the others, but never itself
  const sites = qubicaLocalSites.filter(
    (site) => site.id !== qubicaCurrentSiteId,
  );

  return (
    <Select
      placeholder={intl.formatMessage(messages.qubica_locale_selector_title)}
      className={styles.qubica_locale_selector}
    >
      <>
        {sites.map((site) => (
          <SelectItem key={site.id} className={styles.selector_item}>
            <a href={site.href}>
              {typeof site.title === 'string'
                ? site.title
                : intl.formatMessage(site.title)}
            </a>
          </SelectItem>
        ))}
      </>
    </Select>
  );
}
